import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const FlaskShape = ({ width = 24, height = 24 }: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.65006 10.5936L10.9643 6.27931C10.3772 6.03495 9.6817 5.6335 9.024 4.97578C8.36617 4.31795 7.96466 3.62239 7.7203 3.03516L3.40598 7.34949C3.06932 7.68619 2.90096 7.85454 2.7562 8.0401C2.58541 8.25908 2.439 8.49597 2.31954 8.74663C2.21826 8.95914 2.14298 9.18501 1.99241 9.63668L1.19843 12.0187C1.12434 12.2409 1.18219 12.486 1.34787 12.6517C1.51356 12.8174 1.75863 12.8752 1.98091 12.8011L4.36286 12.0071C4.81455 11.8566 5.04041 11.7813 5.25291 11.68C5.50357 11.5606 5.74048 11.4142 5.95945 11.2434C6.14501 11.0986 6.31342 10.9302 6.65006 10.5936Z"
        fill="#1C274C"
      />
      <path
        d="M12.1615 5.08295C13.0573 4.18711 13.0573 2.73469 12.1615 1.83887C11.2656 0.943035 9.81319 0.943035 8.91736 1.83887L8.39995 2.35631C8.40706 2.3777 8.41436 2.39939 8.422 2.42136C8.61164 2.96804 8.96951 3.68467 9.64268 4.35784C10.3158 5.03101 11.0325 5.38886 11.5792 5.57852C11.601 5.58611 11.6226 5.59343 11.6439 5.60048L12.1615 5.08295Z"
        fill="#1C274C"
      />
    </svg>
  );
};

export default FlaskShape;
